const typeMap: Record<string, string> = {
  blog: 'Blog',
  feature: 'Feature',
  techTip: 'Tech Tip',
  caseStudy: 'Case Study',
  video: 'Video',
  whatIsNew: "What's New",
  spotlight: 'Spotlight',
};

export function contentTypeToLabel(_type: string): string {
  return _type in typeMap ? (typeMap[_type] ?? _type) : _type;
}
